// extracted by mini-css-extract-plugin
export default {"fildBox":"customselect_fildBox__Tb1MR"};